import { render, staticRenderFns } from "./PassionsSectionV2.vue?vue&type=template&id=1fc9fe5e&lang=pug&"
import script from "./PassionsSectionV2.vue?vue&type=script&lang=ts&"
export * from "./PassionsSectionV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports